module.exports = __webpack_public_path__ + "static/media/Footer_Tablet.07942035.jpg";